<script setup lang="ts"></script>

<template>
    <Modal modal-name="price-in-pharmacy-modal" modal-class="price-in-pharmacy-modal" size="xl" :title="$t('priceInPharmacy.modalTitle')">
        <div class="pharmacy-price--wrapper">
            <div class="pharmacy-price--text" v-html="$t('priceInPharmacy.modalText')"></div>
            <div class="pharmacy-price--point-wrapper">
                <div>
                    <div class="pharmacy-price--point">
                        <div class="pharmacy-price--icon">
                            <img
                                :src="'/nuxt-assets/images/png/sprites/home-plus.png'"
                                :alt="$t('priceInPharmacy.modalFirstPoint')"
                                width="34"
                                height="34"
                            />
                        </div>
                        <div class="pharmacy-price--point-text">
                            <span v-html="$t('priceInPharmacy.modalFirstPoint')"></span>
                        </div>
                    </div>
                    <div class="pharmacy-price--point">
                        <div class="pharmacy-price--icon">
                            <img
                                :src="'/nuxt-assets/images/png/sprites/barcode.png'"
                                :alt="$t('priceInPharmacy.modalSecondPoint')"
                                width="34"
                                height="34"
                            />
                        </div>
                        <div class="pharmacy-price--point-text">
                            <span v-html="$t('priceInPharmacy.modalSecondPoint')"></span>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="pharmacy-price--point">
                        <div class="pharmacy-price--icon">
                            <img
                                :src="'/nuxt-assets/images/png/sprites/discount.png'"
                                :alt="$t('priceInPharmacy.modalSecondPoint')"
                                width="34"
                                height="34"
                            />
                        </div>
                        <div class="pharmacy-price--point-text">
                            <span v-html="$t('priceInPharmacy.modalThirdPoint')"></span>
                        </div>
                    </div>
                    <div class="pharmacy-price--point">
                        <div class="pharmacy-price--icon">
                            <img
                                :src="'/nuxt-assets/images/png/sprites/hearth.png'"
                                :alt="$t('priceInPharmacy.modalSecondPoint')"
                                width="34"
                                height="34"
                            />
                        </div>
                        <div class="pharmacy-price--point-text">
                            <span v-html="$t('priceInPharmacy.modalFourthPoint')"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pharmacy-price--img">
                <img
                    :src="'/nuxt-assets/images/png/phone-pharmacy-qr-code2.png'"
                    :alt="$t('priceInPharmacy.modalSecondPoint')"
                    width="134"
                    height="258"
                    loading="lazy"
                />
            </div>
        </div>
    </Modal>
</template>

<style scoped lang="scss">
.pharmacy-price {
    &--text {
        color: $color-dark;
    }

    &--point-wrapper {
        margin: 1rem 0;

        @include screen-md() {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }

    &--point {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        gap: 1rem;
    }

    &--img {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
